export default "__VITE_ASSET__3a93658d__"